import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Update orchid pro email
 */
export default async function putOrchidProEmail(email: string): Promise<void> {
  const res = await fetchOrchidAPI("/api/users/v1/orchid_pro/email", {
    method: "PUT",
    body: JSON.stringify({ email }),
  });
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return;
}
